import { render } from "./news-skeleton.vue?vue&type=template&id=663b9090&scoped=true"
import script from "./news-skeleton.vue?vue&type=script&lang=js"
export * from "./news-skeleton.vue?vue&type=script&lang=js"

import "./news-skeleton.vue?vue&type=style&index=0&id=663b9090&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663b9090"]])

export default __exports__